<template>
  <CreateEditMerchantForm />
</template>

<script setup lang="ts"></script>
